import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KEY = "awg_visitor_id";
const ADMIN_DEVICE = "awg_admin_device";
const visitorId = () => {
  let v = localStorage.getItem(KEY);
  if (!v) { v = crypto.randomUUID(); localStorage.setItem(KEY, v); }
  return v;
};

export const VisitTracker = () => {
  const { pathname } = useLocation();
  const { user, loading } = useAuth();
  useEffect(() => {
    if (loading) return;
    // Any browser that has ever signed in as admin is excluded for good, even when logged out.
    if (user?.role === "admin") { if (!localStorage.getItem(ADMIN_DEVICE)) { localStorage.setItem(ADMIN_DEVICE, "1"); api.post("/visits/admin-device", { visitor_id: visitorId() }).catch(() => {}); } return; }
    if (localStorage.getItem(ADMIN_DEVICE) || pathname.startsWith("/admin")) return;
    api.post("/visits", { visitor_id: visitorId(), path: pathname }).catch(() => {});
  }, [pathname, loading, user?.role]);
  return null;
};
